var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.93531 0.75891C1.95758 0.772844 1.97859 0.789311 1.99704 0.807677L5.57277 4.27138L9.39163 0.358011C9.58703 0.157877 9.90972 0.15281 10.1108 0.347877C10.128 0.36371 10.1439 0.381444 10.1579 0.399177L10.5946 0.955244C10.7537 1.15918 10.7346 1.44924 10.5487 1.62974L6.70442 5.36641L10.62 9.15881C10.8212 9.35388 10.8256 9.67498 10.6296 9.87511C10.6086 9.89664 10.585 9.91628 10.5608 9.93401L9.97146 10.3539C9.76651 10.4996 9.48582 10.4742 9.30952 10.295L5.56768 6.47031L1.60625 10.321C1.40703 10.5148 1.08752 10.5129 0.890848 10.3165L0.627983 10.055C0.430675 9.85928 0.428766 9.54261 0.622891 9.34438L4.49521 5.37464L1.17153 1.97681C1.00732 1.80898 0.980591 1.55058 1.10598 1.35298L1.4083 0.877344C1.52096 0.700011 1.75709 0.646811 1.93531 0.75891Z",
    fill: "#788589"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.6b697dfe570e05323383c98a890e9459.svg";
export { ForwardRef as ReactComponent };